import { render } from "./ActivityLogs.vue?vue&type=template&id=18b5b086&scoped=true"
import script from "./ActivityLogs.vue?vue&type=script&lang=js"
export * from "./ActivityLogs.vue?vue&type=script&lang=js"

import "./ActivityLogs.vue?vue&type=style&index=0&id=18b5b086&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src384613071/src/admin-ui-svc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18b5b086"]])

export default __exports__